import { Box, Flex } from 'components/box';
import { Heading } from 'components/typography';
import { trackMoreDealsFooterClick } from '../../../util/tag-manager';
import Button from 'components/button';
import { Link } from 'components/configurable-routing';
import { css } from '@emotion/react';

const MoreProductsFooter = ({
  message = 'Looking for more deals?',
  cta = "Take me to today's deals",
  description,
  link = '/',
  buttonColor = 'primary',
}: {
  message?: string;
  cta?: string;
  description?: string;
  link?: string;
  buttonColor?: string;
}) => (
  <Flex
    aria-label={message}
    py={4}
    flexDirection="column"
    alignItems="center"
    backgroundColor="lightestGrey"
    boxShadow="medium"
    css={css`
      gap: 10px;
    `}
  >
    <Heading fontSize={[5, 6]} textAlign="center">
      {message}
    </Heading>
    {description && (
      <Box
        fontSize={[2, 3]}
        fontFamily="header"
        textAlign="center"
        padding={[2, 0]}
      >
        {description}
      </Box>
    )}
    <Link
      href={link}
      onClick={() =>
        trackMoreDealsFooterClick(window.location.href || '', link)
      }
    >
      <Button width="auto" mt={3} color={buttonColor}>
        {cta}
      </Button>
    </Link>
  </Flex>
);

export default MoreProductsFooter;
